import { userQueryOptions } from "$/lib/queries/user-queries"
import { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

// Mirrors use-user-role.ts's isAdmin for use in a route loader/beforeLoad,
// where hooks aren't available.
export const requireAdmin = async (queryClient: QueryClient) => {
  const user = await queryClient.ensureQueryData(userQueryOptions)

  if (!user?.isAdmin) {
    throw redirect({ to: "/", replace: true })
  }
}
